/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { KTSVG } from '../../../../../../_metronic/helpers';

type Props = {
    tags: any[];
    setMyTag: any;
    setShowCreateAppModal: any;
    setShowCreateAppModalDelete: any
}

export function TableBody({
    tags,
    setMyTag,
    setShowCreateAppModal,
    setShowCreateAppModalDelete,
}: Props) {

    const [largura, setLargura] = useState(window.innerWidth);

    const handleButtonClickDelete = (event: any, tag: any) => {
        event.stopPropagation();
        setMyTag(tag)
        setShowCreateAppModalDelete(true)
    };

    const handleButtonClickUpdate = (event: any, tag: any) => {
        event.stopPropagation();
        tag.idsPlants = tag.plants && tag.plants.length > 0 ? tag.plants.map((plant: any) => plant.id) : [];
        setMyTag(tag)
        setShowCreateAppModal(true)
    };

    const atualizarTamanhoDaTela = () => {
        setLargura(window.innerWidth);
    };

    useEffect(() => {
        window.addEventListener('resize', atualizarTamanhoDaTela);
        return () => {
          window.removeEventListener('resize', atualizarTamanhoDaTela);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

  return (
    <tbody>
        {tags && tags.length !== 0 ?
            tags.map((tag: any) => {
                return (
                    <tr key={tag.id}>
                        <td>
                            <div className='d-flex align-items-center'>
                                <span
                                    className='badge'
                                    style={{backgroundColor: tag.color, color: '#fff'}}
                                >
                                    {tag.name}
                                </span>
                            </div>
                        </td>

                        <td>
                            <span className={`badge ${tag.is_global ? 'badge-light-primary' : 'badge-light-info'}`}>
                                {tag.is_global ? 'Global' : 'Empresa'}
                            </span>
                        </td>

                        <td>
                            <span className='text-dark fw-bold fs-6'>
                                {tag.plants ? tag.plants.length : 0}
                            </span>
                        </td>

                        <td>
                            <span className={`badge ${tag.status === 'ATIVO' ? 'badge-light-success' : 'badge-light-danger'}`}>
                                {tag.status}
                            </span>
                        </td>

                        <td>
                            <div className='d-flex justify-content-end flex-shrink-0'>
                            <a
                                onClick={(event: any) =>{
                                    handleButtonClickUpdate(event, tag)
                                }}
                                href='#'
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            >
                                <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                            </a>
                            <a
                                onClick={(event: any) => {
                                    handleButtonClickDelete(event, tag)
                                }}
                                href='#'
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                            >
                                <KTSVG
                                path='/media/icons/duotune/general/gen027.svg'
                                className='svg-icon-3'
                                />
                            </a>
                            </div>
                        </td>
                    </tr>
                )
            })
        :
        <tr>
            <td colSpan={largura < 1200 ? 2 : 5} style={{textAlign: 'center'}}>
                <div className='d-flex justify-content-center' style={{padding: '2rem'}}>
                    <span className='text-muted fw-semibold text-muted d-block fs-4'>
                        Tags não encontradas!
                    </span>
                </div>
            </td>
        </tr>
        }
    </tbody>
  );
}
